import { render } from "./QuestionOptionCreateEditFormComponent.vue?vue&type=template&id=5d0de0ac"
import script from "./QuestionOptionCreateEditFormComponent.vue?vue&type=script&lang=js"
export * from "./QuestionOptionCreateEditFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_1a3e5399/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__